import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import { AuthContext } from '../../context/AuthContext';
import { EmpresasContext } from '../../context/EmpresasContext';
import useLots, { LotsType } from '../../context/hooks/useLots';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const LotsManagement = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listLots, pageCount, getAllLotsPaged, deleteLots } = useLots();
    const { getAllNetworks, listNetworks, getEmpresasByNetwokr, listEmpresas } = useContext(EmpresasContext);

    const [loading, setLoading] = useState(false);
    const [dataSearch, setDataSearch] = useState({
        empresa: '',
        network: '',
        mesReferencia: '',
        anoVigencia: '',
    });
    const [currentPage, setCurrentPage] = useState(1);
    const months = [
        { value: 'Janeiro', label: 'Janeiro' },
        { value: 'Fevereiro', label: 'Fevereiro' },
        { value: 'Marco', label: 'Março' },
        { value: 'Abril', label: 'Abril' },
        { value: 'Maio', label: 'Maio' },
        { value: 'Junho', label: 'Junho' },
        { value: 'Julho', label: 'Julho' },
        { value: 'Agosto', label: 'Agosto' },
        { value: 'Setembro', label: 'Setembro' },
        { value: 'Outubro', label: 'Outubro' },
        { value: 'Novembro', label: 'Novembro' },
        { value: 'Dezembro', label: 'Dezembro' },
    ];

    const years = Array.from({ length: 10 }, (_, i) => {
        const year = new Date().getFullYear() - i;
        return { value: year.toString(), label: year.toString() };
    });

    useEffect(() => {
        fetchNetworks();
        fetchLots(1);
    }, []);

    const fetchLots = async (pageNumber: number, filters = dataSearch) => {
        setLoading(true);
        try {
            await getAllLotsPaged(
                pageNumber,
                filters.empresa,
                filters.network,
                filters.mesReferencia,
                filters.anoVigencia ? parseInt(filters.anoVigencia) : undefined
            );
        } catch (error) {
            console.error("Erro ao buscar lotes:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchNetworks = async () => {
        try {
            setLoading(true);
            await getAllNetworks();
        } catch (error) {
            console.error("Erro ao carregar redes:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleNetworkChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
        const network = event.target.value;
        setDataSearch((prev) => ({ ...prev, network, empresa: '' }));
        if (network) {
            setLoading(true);
            try {
                await getEmpresasByNetwokr(network);
            } catch (error) {
                console.error("Erro ao carregar empresas:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    const onChangePaginationCommon = async (e: any, value: any) => {
        setCurrentPage(value);
        await fetchLots(value, dataSearch);
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, [e.target.name]: e.target.value });
    };

    const handleSearchSubmit = () => {
        fetchLots(1, dataSearch);
    };

    const handleClearFilters = async () => {
        const clearedFilters = {
            empresa: '',
            network: '',
            mesReferencia: '',
            anoVigencia: '',
        };
    
        setDataSearch(clearedFilters);
        fetchLots(1, clearedFilters);
    };

    const handleDeleteLots = (lotId: number) => {
        MySwal.fire({
            title: 'Tem certeza?',
            text: "Esta ação não pode ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, deletar!',
            cancelButtonText: 'Cancelar'
        }).then((result: any) => {
            if (result.isConfirmed) {
                setLoading(true);
                deleteLots(lotId)
                    .then(() => {
                        MySwal.fire(
                            'Deletado!',
                            'O lote foi excluído com sucesso.',
                            'success'
                        );
                        fetchLots(currentPage, dataSearch);
                    })
                    .catch((error) => {
                        MySwal.fire(
                            'Erro!',
                            'Houve um problema ao excluir o lote.',
                            'error'
                        );
                    })
                    .finally(() => setLoading(false));
            }
        });
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Gerenciar Lotes"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row>
                    <Col xs="12">
                        <Form className="search-form d-flex align-items-center justify-content-between">
                            <FormGroup className="me-3 mb-0" style={{ flex: '0.2' }}>
                                <Label for="network">Rede</Label>
                                <select
                                    className="form-control form-control-alternative"
                                    name="network"
                                    id="network"
                                    value={dataSearch.network}
                                    onChange={handleNetworkChange}
                                >
                                    <option value="">Selecione uma Rede</option>
                                    {listNetworks.map((network, index) => (
                                        <option key={index} value={network.name}>{network.name}</option>
                                    ))}
                                </select>
                            </FormGroup>
                            <FormGroup className="me-3 mb-0" style={{ flex: '0.2' }}>
                                <Label for="empresa">Empresa</Label>
                                <Input
                                    type="select"
                                    className="form-control form-control-alternative"
                                    name="empresa"
                                    id="empresa"
                                    value={dataSearch.empresa}
                                    onChange={handleSearchChange}
                                    disabled={!dataSearch.network}
                                >
                                    <option value="">Selecione uma Empresa</option>
                                    {listEmpresas.map((empresa, index) => (
                                        <option key={index} value={empresa.name}>{empresa.name}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <FormGroup className="me-3 mb-0" style={{ flex: '0.2' }}>
                                <Label for="mesReferencia">Mês de Referência</Label>
                                <Input
                                    type="select"
                                    className="form-control form-control-alternative"
                                    name="mesReferencia"
                                    id="mesReferencia"
                                    value={dataSearch.mesReferencia}
                                    onChange={handleSearchChange}
                                >
                                    <option value="">Selecione um Mês</option>
                                    {months.map((month) => (
                                        <option key={month.value} value={month.value}>{month.label}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <FormGroup className="me-3 mb-0" style={{ flex: '0.2' }}>
                                <Label for="anoVigencia">Ano de Vigência</Label>
                                <Input
                                    type="select"
                                    className="form-control form-control-alternative"
                                    name="anoVigencia"
                                    id="anoVigencia"
                                    value={dataSearch.anoVigencia}
                                    onChange={handleSearchChange}
                                >
                                    <option value="">Selecione um Ano</option>
                                    {years.map((year) => (
                                        <option key={year.value} value={year.value}>{year.label}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <div className="d-flex align-items-center" style={{ flex: '0.15' }}>
                                <Button
                                    color="primary"
                                    className="me-2 align-self-center"
                                    onClick={handleSearchSubmit}
                                    style={{ color: "#FFF", backgroundColor: "#2c2c2c",top: '15px' }}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    color="secondary"
                                    className="align-self-center"
                                    onClick={handleClearFilters}
                                    style={{ top: '15px' }}
                                >
                                    Limpar
                                </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col>
                        <Table hover responsive className="table-striped custom-table">
                            <thead>
                                <tr>
                                    <th>Número do lote</th>
                                    <th>Empresa</th>
                                    <th>Rede</th>
                                    <th>Mês de referência dos dados</th>
                                    <th>Ano de vigência</th>
                                    <th>Data de submissão</th>
                                    <th>Remover dados do lote</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listLots.map((lots: LotsType, index: number) => {
                                    return (
                                        <tr key={index}>
                                            <td>{lots.id}</td>
                                            <td>{lots.empresa}</td>
                                            <td>{lots.network}</td>
                                            <td>{lots.mesReferencia}</td>
                                            <td>{lots.anoVigencia}</td>
                                            <td>{new Date(lots.submissionDate).toLocaleDateString()}</td>
                                            <td>
                                                <Button onClick={() => handleDeleteLots(lots.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-end mt-3">
                            {pageCount && (
                                <div className="d-flex justify-content-center mt-4">
                                    <PaginationMaterial
                                        onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                        key={pageCount}
                                        count={pageCount}
                                    />
                                </div>
                            )}
                            {listLots.length === 0 && (
                                <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default LotsManagement;
